<template>
  <n-modal class="upgrade-modal" @cancel="closeUpgradeModal">
    <div slot="title">
      <div class="upgrade-modal__header">
        <h2>Upgrade to unlock these features</h2>
        <p>
          Your subscription doesn't cover these features. To benefit from the full power of Liberty Connect, our sales
          team would be happy to help you upgrade.
        </p>
      </div>
    </div>
    <div slot="body">
      <div class="upgrade-modal__body">
        <div class="columns is-4">
          <div class="column">
            <div class="upgrade-modal__feature">
              <div class="upgrade-modal__feature-header">
                <FlowIcon></FlowIcon>
                <span class="title">Flows</span>
              </div>
              <div class="upgrade-modal__feature-body">
                <h4>Scale every part of your business</h4>
                <p>Automate and personalise your digital experience</p>
                <ul>
                  <li>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="15" viewBox="0 0 20 15" fill="none">
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M7.143 14.886L0 7.743L2.014 5.729L7.143 10.843L17.986 0L20 2.029L7.143 14.886Z"
                        fill="#FF6666"
                      ></path></svg
                    >Design your own conversation flow
                  </li>
                  <li>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="15" viewBox="0 0 20 15" fill="none">
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M7.143 14.886L0 7.743L2.014 5.729L7.143 10.843L17.986 0L20 2.029L7.143 14.886Z"
                        fill="#FF6666"
                      ></path></svg
                    >Triage conversations automatically
                  </li>
                  <li>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="15" viewBox="0 0 20 15" fill="none">
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M7.143 14.886L0 7.743L2.014 5.729L7.143 10.843L17.986 0L20 2.029L7.143 14.886Z"
                        fill="#FF6666"
                      ></path></svg
                    >Proactively capture more leads 24/7
                  </li>
                </ul>
                <a @click="chatWithUsClicked()"
                  >Find out how
                  <svg viewBox="0 0 27 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M15.373 2.635l9.531 10.237-9.992 9.765M24.344 13H-.001"
                      stroke="#f66"
                      stroke-width="2"
                    /></svg
                ></a>
              </div>
            </div>
          </div>
          <div class="column">
            <div class="upgrade-modal__feature">
              <div class="upgrade-modal__feature-header">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  enable-background="new 0 0 24 24"
                  height="24"
                  viewBox="0 0 24 24"
                  width="24"
                >
                  <g><rect fill="none" height="24" width="24" /></g>
                  <g>
                    <g>
                      <path
                        d="M15.82,7.22l-1,0.4c-0.21-0.16-0.43-0.29-0.67-0.39L14,6.17C13.98,6.07,13.9,6,13.8,6h-1.6c-0.1,0-0.18,0.07-0.19,0.17 l-0.15,1.06c-0.24,0.1-0.47,0.23-0.67,0.39l-1-0.4c-0.09-0.03-0.2,0-0.24,0.09l-0.8,1.38c-0.05,0.09-0.03,0.2,0.05,0.26l0.85,0.66 C10.02,9.73,10,9.87,10,10c0,0.13,0.01,0.26,0.03,0.39l-0.84,0.66c-0.08,0.06-0.1,0.17-0.05,0.25l0.8,1.39 c0.05,0.09,0.15,0.12,0.25,0.09l0.99-0.4c0.21,0.16,0.43,0.29,0.68,0.39L12,13.83c0.02,0.1,0.1,0.17,0.2,0.17h1.6 c0.1,0,0.18-0.07,0.2-0.17l0.15-1.06c0.24-0.1,0.47-0.23,0.67-0.39l0.99,0.4c0.09,0.04,0.2,0,0.24-0.09l0.8-1.39 c0.05-0.09,0.03-0.19-0.05-0.25l-0.83-0.66C15.99,10.26,16,10.13,16,10c0-0.14-0.01-0.27-0.03-0.39l0.85-0.66 c0.08-0.06,0.1-0.17,0.05-0.26l-0.8-1.38C16.02,7.22,15.91,7.19,15.82,7.22z M13,11.43c-0.79,0-1.43-0.64-1.43-1.43 S12.21,8.57,13,8.57s1.43,0.64,1.43,1.43S13.79,11.43,13,11.43z"
                      />
                      <path
                        d="M19.94,9.06c-0.43-3.27-3.23-5.86-6.53-6.05C13.27,3,13.14,3,13,3C9.47,3,6.57,5.61,6.08,9l-1.93,3.48 C3.74,13.14,4.22,14,5,14h1v2c0,1.1,0.9,2,2,2h1v3h7v-4.68C18.62,15.07,20.35,12.24,19.94,9.06z M14.89,14.63L14,15.05V19h-3v-3H8 v-4H6.7l1.33-2.33C8.21,7.06,10.35,5,13,5c2.76,0,5,2.24,5,5C18,12.09,16.71,13.88,14.89,14.63z"
                      />
                    </g>
                  </g>
                </svg>
                <span class="title">FAQs</span>
              </div>
              <div class="upgrade-modal__feature-body">
                <h4>24/7 automated support with FAQs</h4>
                <p>Support automation that resolves the most common questions for you</p>
                <ul>
                  <li>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="15" viewBox="0 0 20 15" fill="none">
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M7.143 14.886L0 7.743L2.014 5.729L7.143 10.843L17.986 0L20 2.029L7.143 14.886Z"
                        fill="#FF6666"
                      ></path></svg
                    >Speed up customer resolutions
                  </li>
                  <li>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="15" viewBox="0 0 20 15" fill="none">
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M7.143 14.886L0 7.743L2.014 5.729L7.143 10.843L17.986 0L20 2.029L7.143 14.886Z"
                        fill="#FF6666"
                      ></path></svg
                    >Easy to train automation
                  </li>
                  <li>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="15" viewBox="0 0 20 15" fill="none">
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M7.143 14.886L0 7.743L2.014 5.729L7.143 10.843L17.986 0L20 2.029L7.143 14.886Z"
                        fill="#FF6666"
                      ></path></svg
                    >Eliminate repetitive work
                  </li>
                </ul>
                <a @click="chatWithUsClicked()"
                  >Read more
                  <svg viewBox="0 0 27 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M15.373 2.635l9.531 10.237-9.992 9.765M24.344 13H-.001"
                      stroke="#f66"
                      stroke-width="2"
                    /></svg
                ></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div slot="buttons">
      <n-button-group>
        <n-button @click="chatWithUsClicked()" variant="primary">Chat with us</n-button>
        <n-button variant="primary--outline" @click="closeUpgradeModal">Cancel</n-button>
      </n-button-group>
    </div>
  </n-modal>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import FlowIcon from 'vue-material-design-icons/Waves.vue';
import appInsights from '@/shared/services/appInsights';
import { useStore } from 'vuex';

const store = useStore();
const currentWorkspace = computed(() => store.getters.currentWorkspace);

const emit = defineEmits<{
  (e: 'close'): void;
}>();

function closeUpgradeModal() {
  emit('close');
}

function chatWithUsClicked() {
  appInsights.trackEvent({ name: 'Upgrade modal: "chat with us" clicked' }, { workspaceId: currentWorkspace.value.id });
  window.open(
    'https://www.netcall.com/liberty-connect-custom-flows-and-triage-bots?openConversation=true&utm_source=connect&utm_campaign=subscription_upgrade',
    '_blank',
  );
}
</script>

<style scoped lang="scss">
.upgrade-modal {
  :deep(.n-modal__modal) {
    width: 800px !important;
  }
  &__header {
    margin-right: 2rem;
    h2 {
      font-size: 1.5rem;
    }
    p {
      opacity: 0.9;
      line-height: 1.35;
    }
  }
  &__body {
    .columns {
      align-items: stretch;
      justify-content: space-around;
      h3 {
        font-size: 1.25rem;
      }
    }
    .column {
      padding: 2rem;
      &:nth-of-type(2) {
        padding-left: 0;
      }
    }
  }
  &__introduction {
    margin-bottom: 1rem;
  }
  &__feature {
    box-shadow: 1px 1px 10px rgb(0 0 0 / 10%);
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  &__feature-header {
    background: $secondary;
    padding: 3rem 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    .title {
      font-size: 2rem;
      color: #fff;
      margin-left: 0.5rem;
    }

    .material-design-icon {
      width: auto;
      height: auto;
    }
    svg {
      width: 3rem;
      height: 3rem;
      fill: #fff;
      position: relative;
      bottom: 0;
    }
  }
  &__feature-body {
    padding: 1rem;
    flex: 1 0 auto;
    display: flex;
    flex-direction: column;
    h4 {
      font-weight: bold;
      margin-bottom: 1.5rem;
    }
    p {
      margin-bottom: 1.5rem;
    }
    ul {
      margin-bottom: 1.5rem;
      li {
        svg {
          margin-right: 0.5rem;
          width: 20px;
          height: 15px;
        }
      }
    }
    a {
      color: $primary;
      font-weight: bold;
      margin-top: auto;
      svg {
        width: 14px;
        height: 14px;
        margin-left: 12px;
        position: relative;
        transition: all 0.1125s linear;
      }
      &:hover {
        svg {
          transform: translateX(50%);
        }
      }
    }
  }
}
</style>
